import { moneyFormat } from "common/utils/filters/money";

export const tierBreakdown = deliveryData =>
  Array.isArray(deliveryData?.tier_breakdown) ? deliveryData.tier_breakdown : [];

export const formatMoneyWithoutTrailingCents = value => {
  if (value == null || value === "") return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;

  return moneyFormat(numeric).replace(/\.00$/, "");
};

export const headlineTierDisclosure = tier => {
  const segments = [];
  const price = Number(tier?.customer_price);
  const priceLabel = formatMoneyWithoutTrailingCents(price);
  const thresholdLabel = formatMoneyWithoutTrailingCents(tier?.free_shipping_threshold);

  if (Number.isFinite(price) && price > 0 && priceLabel) segments.push(`for ${priceLabel}`);
  if (thresholdLabel) segments.push(`on orders over ${thresholdLabel}`);

  return segments.length ? `${segments.join(" ")}. ` : "";
};

export const headlineTierDisclosureText = deliveryData => {
  const [headlineTier] = tierBreakdown(deliveryData);
  return headlineTierDisclosure(headlineTier);
};

export const shouldShowUpsellTier = tier => Boolean(tier?.date && tier?.free === true);

export const upsellTierNote = tier => {
  const thresholdLabel = formatMoneyWithoutTrailingCents(tier?.free_shipping_threshold);

  return thresholdLabel ? ` for <b>FREE</b> on orders over ${thresholdLabel}` : " for <b>FREE</b>";
};
